import { get } from "lodash"

export const processPlatformAccount = (rawData) => {
    return {
        id: get(rawData, 'id'),
        // status: get(rawData, 'status'),
        enable: Boolean(get(rawData, 'enable')),
        routeType: get(rawData, 'routeType'),
        method: get(rawData, 'routeType') === 'sct' ? 'sepa' : get(rawData, 'routeType'),
        currency: get(rawData, 'currency'),
        routeCode: get(rawData, 'routeCode'),
        bankAddress: get(rawData, 'bankAddress'),
        bankName: get(rawData, 'bankName'),
        companyAddress: get(rawData, 'companyAddress'),
        companyName: get(rawData, 'companyName'),
        contactEmail: get(rawData, 'contactEmail'),
        isLocal: get(rawData, 'type')==='L',
        isInternational: get(rawData, 'type')==='I',
        createdAt: get(rawData, 'createdAt'),
        priority: get(rawData, 'priority'),
        accountNumber: get(rawData, 'accountNumber'),
        // swift: get(rawData, 'routeCode'),
        // bankCountry: get(rawData, 'bankCountry'),
        // iban: get(rawData, 'accountNumberType') === 'iban' ? get(rawData, 'accountNumber') : '',
        // accountNumber: get(rawData, 'accountNumberType') === 'iban' ? '' : get(rawData, 'accountNumber'),
        // accountHolderName: get(rawData, 'accountHolderName'),
        bankCountry: get(rawData, 'bankCountry'),
        postCode: get(rawData, 'postCode'),
        rawData,
    };
}